// ============================================================================
// apps/voiceRoomsRenderer.tsx — ПРИЛОЖЕНИЕ «Голосовые комнаты» (волна 2, D7).
//
// Рендерер appKind/code 'voice_rooms': список постоянных голосовых комнат,
// создание/вход, участники/роли/микрофоны и медиа (LiveKit). Доступен всем
// авторизованным — состояние и права проверяет СЕРВЕР (VoiceRoomService):
// видимость приватной комнаты/вход — по ролям (settings.role_ids), управление
// участниками — создатель/модератор/админ. Данные — через штатный SDK
// (getSDK().voiceRooms) внутри экрана, как в remoteRenderer/vpnRenderer.
//
// Точка входа: приложение по КОДУ (AppPage `/designer/app/voice_rooms`,
// AppHost из дока/«Пуска»/публикации — когда в конфигурации есть запись
// kind='app' code='voice_rooms' и она включена в состав воркспейса).
// ============================================================================

import { registerAppRenderer, type AppManifest, APPSDK_VERSION } from '@/lib/apps/sdk';
import { VoiceRoomsScreen } from '@/components/voice-rooms/VoiceRoomsScreen';

/** Код приложения (kind='app'.code) и вид рендерера — единый ключ. */
export const VOICE_ROOMS_APP_CODE = 'voice_rooms';

/** Манифест приложения «Голосовые комнаты» (AppHost): на весь воркспейс. */
export const VOICE_ROOMS_APP_MANIFEST: AppManifest = {
  code: VOICE_ROOMS_APP_CODE,
  name: 'voice_rooms',
  synonym: 'Голосовые комнаты',
  appKind: VOICE_ROOMS_APP_CODE,
  area: 'full',
  apiVersion: APPSDK_VERSION,
  permissions: ['events', 'notify', 'nav'],
};

function VoiceRoomsApp() {
  return <VoiceRoomsScreen />;
}

export function registerVoiceRoomsApp(): void {
  registerAppRenderer({
    appKind: VOICE_ROOMS_APP_CODE,
    code: VOICE_ROOMS_APP_CODE,
    title: 'Голосовые комнаты',
    Component: VoiceRoomsApp,
    manifest: VOICE_ROOMS_APP_MANIFEST,
  });
}
